import { render } from "./EventDetailModal.vue?vue&type=template&id=29f9951d&scoped=true"
import script from "./EventDetailModal.vue?vue&type=script&lang=js"
export * from "./EventDetailModal.vue?vue&type=script&lang=js"

import "./EventDetailModal.vue?vue&type=style&index=0&id=29f9951d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f9951d"],['__file',"src/containers/event/eventSettings/EventDetailModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29f9951d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29f9951d', __exports__)) {
    api.reload('29f9951d', __exports__)
  }
  
  module.hot.accept("./EventDetailModal.vue?vue&type=template&id=29f9951d&scoped=true", () => {
    api.rerender('29f9951d', render)
  })

}


export default __exports__